import React, {useState} from 'react';
import { NavLink } from 'react-router-dom'
import '../css/navbar.css'

const Navbar = () => {
    const [toggle, setToggle] = useState(false)
    return (
        <nav className='navbar'>
            <div className="brand-title">JobsWeb</div>
            <div className="toggle-button" onClick={() => setToggle(!toggle)}>
                <span className="bar"></span>
                <span className="bar"></span>
                <span className="bar"></span>
            </div>
            <div className={toggle?"navbar-links active": "navbar-links"}>
                <NavLink to='/' className='links'>Home</NavLink>
                <NavLink to='/about' className='links'>About</NavLink>
                <NavLink to='/' className='links'>Contact</NavLink>
            </div>   
        </nav>
    );
};

export default Navbar;